// ** Third Party Components
import BtnContent from "components/layout/Btn/components/BtnContent";
import styled from "styled-components";

// ** Custom Components
import { Icon } from "components/icons";

// ** Styles Import
import { breakpoints } from "styles/grid";

// #####################################################

export const StyledScrollToTopButton = styled((props) => <button {...props} />)`
	font-size: 1.75rem;
	position: fixed;
	bottom: 1rem;
	right: 1rem;
	width: 60px;
	height: 60px;
	border-radius: 50%;
	z-index: 998 !important;
	display: flex;
	align-items: center;
	font-weight: bold;
	justify-content: center;
	background-color: var(--dz-sys-input-background-color);
	border: 1px solid var(--dz-sys-input-border-color);

	&:hover,
	&:active {
		border: 1px solid var(--dz-sys-input-border-color-hover);
		box-shadow: var(--dz-sys-input-shadow);
	}

	@media (max-width: ${breakpoints.giant - 1}px) {
		font-size: 1.75rem;
		width: 50px;
		height: 50px;
	}
`;

// #####################################################

export const ScrollToTopButton = (props) => {
	// #####################################################

	return (
		<StyledScrollToTopButton {...props}>
			<BtnContent
				iconNew={
					<Icon name="arrow-up" color="var(--dz-sys-text-color)" />
				}
				iconOnly
			/>
		</StyledScrollToTopButton>
	);
};

// #####################################################
